<template>
  <mu-card class="aio-input">
    <mu-card-actions class="aio-input-header pointer" @click.native="toggle">
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="22px" height="22px" viewBox="0 0 24 24" version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <linearGradient x1="0%" y1="100%" x2="98.4753667%" y2="1.52463329%" id="linearGradient-1">
              <stop stop-color="#FF7950" offset="0%"></stop>
              <stop stop-color="#F42C2A" offset="100%"></stop>
            </linearGradient>
          </defs>
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icons/Light/Cards/ic_hba1c">
              <g id="ic_bloodglucose">
                <rect id="bounds" x="0" y="0" width="24" height="24"></rect>
                <path
                  d="M16.7141425,15.4206675 C16.7141425,14.3305871 16.3089743,12.0255408 14.6252466,9.85941762 C13.1714601,7.98914179 10.8003551,3 10.8003551,3 C10.8003551,3 8.54268237,7.98914179 7.08889592,9.85938459 C5.40516818,12.0255078 5,14.330554 5,15.4206675 C5,18.2970952 7.58662631,20.6348409 10.8003551,20.6887454 L10.8003551,20.6900005 C10.8192976,20.6900005 10.8381659,20.6895051 10.8570712,20.689373 C10.8760137,20.6895381 10.894882,20.6900005 10.9138244,20.6900005 L10.9138244,20.6887454 C14.1275162,20.6348409 16.7141425,18.2970952 16.7141425,15.4206675 L16.7141425,15.4206675 Z"
                  id="Shape" fill="url(#linearGradient-1)"></path>
              </g>
              <path
                d="M10.3372489,11.445418 L10.3372489,11.445418 L10.3372489,11.445418 C10.0734114,11.7092555 10.0728335,12.1368422 10.3359569,12.4013919 L13.3932177,15.4752261 L13.3932177,15.4752261 C13.7826849,15.8668046 14.4158475,15.8685161 14.8074261,15.4790489 C14.808048,15.4784303 14.8086692,15.4778109 14.8092895,15.4771906 L16.136795,14.1498748 L18.6001799,16.6132598 L18.6001799,16.6132598 C18.8637287,16.8768085 19.2910256,16.8768085 19.5545743,16.6132598 L19.5545743,16.6132598 L19.5545743,16.6132598 C19.815976,16.351858 19.815976,15.9280421 19.5545743,15.6666403 C19.5532838,15.6653498 19.551988,15.6640646 19.550687,15.6627847 L16.8119508,12.96849 L16.8119508,12.96849 C16.4204799,12.5833715 15.7916925,12.5859891 15.4034415,12.9743535 L14.1121987,14.2659734 L11.2919132,11.4454391 L11.2919132,11.4454391 C11.0283074,11.18181 10.6008991,11.1817911 10.33727,11.4453969 C10.337263,11.445404 10.3372559,11.445411 10.3372489,11.445418 Z"
                id="Page-1" fill="#B8E986"
                transform="translate(14.944809, 14.029313) rotate(3.000000) translate(-14.944809, -14.029313) "></path>
            </g>
          </g>
        </svg>
        <mu-flexbox-item class="left16" v-text="title" style="color: #FB5940;"></mu-flexbox-item>
        <mu-flexbox-item align="right">
          <mu-icon-button
            class="card-bar-icon blueIcon"
            :icon="isOpenInput ? 'remove_circle_outline' : 'add_circle'"

          />
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>


    <form v-if="isOpenInput" novalidate style="overflow: hidden">
      <mu-card-text>
        <mu-row>
          <mu-col width="100" tablet="50" desktop="50" v-if="$store.state.user.settings.hba1c.measure === 'percentage'">
            <mu-text-field
              v-validate
              data-vv-validate-on="none"
              :data-vv-rules="'min_value:0|max_value:25'"
              data-vv-name="hba1c_percent"
              :data-vv-as="$store.state.user.settings.hba1c.unit"
              data-vv-value-path="inputValue"
              :errorText="errors.first('hba1c_percent')"
              :label="$t('message.cardHbA1c')"
              v-model.number="model.percent"
              :hintText="$t('message.placeholderText')"
              :fullWidth="true"
              :helpText="$store.state.user.settings.hba1c.unit"
            />
          </mu-col>
          <mu-col width="100" tablet="50" desktop="50" v-if="$store.state.user.settings.hba1c.measure === 'mmol-mol'">
            <mu-text-field
              v-validate
              data-vv-validate-on="none"
              :data-vv-rules="'min_value:0|max_value:300'"
              data-vv-name="hba1c_mmol_mol"
              :data-vv-as="$store.state.user.settings.hba1c.unit"
              data-vv-value-path="inputValue"
              :errorText="errors.first('hba1c_mmol_mol')"
              :label="$t('message.cardHbA1c')"
              v-model.number="model.mmol_mol"
              :hintText="$t('message.placeholderText')"
              :fullWidth="true"
              :helpText="$store.state.user.settings.hba1c.unit"
            />
          </mu-col>
        </mu-row>
        <div class="bottom"></div>
      </mu-card-text>
    </form>
  </mu-card>
</template>
<script type="text/babel">

  import HbA1cApi from '../../../../api/Tracking/HbA1c'
  import config from '../../../../config'


  export default {
    name: 'aio-hba1c',
    props: {
      hba1c: {}
    },
    data() {
      return {
        isSaving: false,
        title: this.$t('message.cardHbA1c'),
        isOpenInput: false,
        scroller: document.getElementsByClassName('main-content')[0],
        model: {
          mmol_mol: null,
          percent: null
        }
      }
    },
    watch: {
      'model.percent': function () {
        this.trySubmitAndEmitValue();
      },
      'model.mmol_mol': function () {
        this.trySubmitAndEmitValue();

      }
    },
    mounted() {
      let self = this;
    },
    methods: {
      formatDate(date) {
        return config.dateFormatting.fromNow(date);
      },
      trySubmitAndEmitValue() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              let model = {};
              if (self.$store.state.user.settings.hba1c.measure === 'mmol-mol') {
                model.mmol_mol = self.model.mmol_mol;
              }
              else {
                model.percent = self.model.percent;
              }
              self.$emit('onValid', model);
            }
            else {
              self.$emit('onValid', null);
            }
          })
      },
      toggle() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HbA1c.vue?65aad83a